/** 今日 */
export const today = new Date();
/** 今年度 */
export const thisYear = today.getFullYear() - Number(today.getMonth() < 3);
/** 今学期 */
export const thisSemester = (Math.floor(today.getMonth() / 3 + 3) % 4) + 1;
